<template>
  <div v-if="error">
    <div>There's been an error logging in.</div>
    Please click back, reload and try again.
  </div>
  <div v-else>
    <Loading />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { useUserStore } from "../store/userStore";
import { useBldgStore } from "../store/bldgStore";
import router from "../router";

/*
  This page is for deeplinks to VR.
  It will check if user is loaded and then redirect to the api which redirects to VR launch URL

*/

const route = useRoute();
const userStore = useUserStore();
const bldgStore = useBldgStore();
const error = ref(false);

var property = computed(() => bldgStore.property);

var isLoggedIn = computed(() => userStore.isLoggedIn);
var isUserLoading = computed(() => userStore.isUserLoading);
var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);

watch(property, redirectAfterUserLoaded);
watch(isLoggedIn, redirectAfterUserLoaded);
watch(isUserLoading, redirectAfterUserLoaded);
watch(isUserLoadedFromServer, redirectAfterUserLoaded);
onMounted(async () => {
  console.log("Start Tour page mounted");
  await redirectAfterUserLoaded();
});

async function redirectAfterUserLoaded() {
  // this page will keep showing loading animation until redirect or error.
  // This function gets called repeatedly as things load
  if (error.value) return;

  if (property.value) {
    let siteCode = route.params?.sitecode?.toString();
    let userLoadingNotStarted = !isUserLoadedFromServer.value && !isUserLoading.value;

    if (siteCode && userLoadingNotStarted) {
      await userStore.getUser(siteCode, property.value.portalId);
    }

    let userLoadingComplete = isUserLoadedFromServer.value && !isUserLoading.value;

    if (userLoadingComplete) {
      var user = userStore.user;
      if (isLoggedIn.value && user?.personId > 0) {
        if (userStore.isEmailVerifiedOrNotRequired) {
          var vrLaunchRedirect = `/api/launch/starttour/${siteCode}/${user?.personId}`;

          console.log("User Loaded. redirecting to " + vrLaunchRedirect);
          location.replace(vrLaunchRedirect);
        } else {
          router.push(`/${siteCode}/unconfirmedemail`);
        }
      } else {
        error.value = true;
      }
    }
  }
}
</script>
